export class PublisherModel {
    publisherAllCols: any[] = [];
    publisherColFilterOptions: any[] = [];
    publisherCols: any[] = [];
    constructor() {
        // for Daily Creative Sheet Main Columns
        this.publisherAllCols = [
            { field: "publisher_name", header: "Publisher Name", type: false },
            // { field: "report_date", header: "Date" ,type:true},
            // { field: "report_day", header: "Day" ,type:true},
            // { field: "segment_name", header: "Segment Name" ,type:true},
            // { field: "offer_name", header: "Offer Name" ,type:true},
            // { field: "network_name", header: "Network Name" ,type:true},
            // { field: "creative_name", header: "Creative Name" ,type:true},
            // { field: "from_line", header: "From Line" ,type:true},
            // { field: "subject_line", header: "Subject Line" ,type:true},
            { field: "sent_count", header: "Sent", type: true },
            { field: "opens", header: "Opens", type: true },
            { field: "open_rate", header: "Open%", type: true },
            { field: "clicks", header: "Clicks", type: true },
            { field: "click_rate", header: "CTR", type: true },
            { field: "network_clicks", header: "N/W Click", type: true },
            { field: "unsub", header: "Unsub", type: true },
            { field: "unsub_rate", header: "Unsub%", type: true },
            { field: "utr", header: "UTR", type: true },
            { field: "conversion", header: "Conversions", type: true },
            { field: "conversion_rate", header: "Conversion%", type: true },
            { field: "revenue", header: "Revenue", type: true },
            { field: "epc", header: "EPC", type: true },
            { field: "epl", header: "EPL", type: true },
            { field: "ecpm", header: "ECPM", type: true },
            { field: "bounce", header: "Bounce", type: true },
            { field: "spam", header: "Spams", type: true },
            { field: "created_by", header: "Uploaded By", type: false }
        ];
        // for Daily Creative Sheet Main Columns Filter Options
        this.publisherColFilterOptions = [
            // { field: "report_date", header: "Date" ,type:true},
            // { field: "report_day", header: "Day" ,type:true},
            // { field: "segment_name", header: "Segment Name" ,type:true},
            // { field: "offer_name", header: "Offer Name" ,type:true},
            // { field: "network_name", header: "Network Name" ,type:true},
            // { field: "creative_name", header: "Creative Name" ,type:true},
            // { field: "from_line", header: "From Line" ,type:true},
            // { field: "subject_line", header: "Subject Line" ,type:true},
            { field: "sent_count", header: "Sent", type: true },
            { field: "opens", header: "Opens", type: true },
            { field: "open_rate", header: "Open%", type: true },
            { field: "clicks", header: "Clicks", type: true },
            { field: "click_rate", header: "CTR", type: true },
            { field: "network_clicks", header: "N/W Click", type: true },
            { field: "unsub", header: "Unsub", type: true },
            { field: "unsub_rate", header: "Unsub%", type: true },
            { field: "utr", header: "UTR", type: true },
            { field: "conversion", header: "Conversions", type: true },
            { field: "conversion_rate", header: "Conversion%", type: true },
            { field: "revenue", header: "Revenue", type: true },
            { field: "epc", header: "EPC", type: true },
            { field: "epl", header: "EPL", type: true },
            { field: "ecpm", header: "ECPM", type: true },
            { field: "bounce", header: "Bounce", type: true },
            { field: "spam", header: "Spams", type: true },
            { field: "created_by", header: "Uploaded By", type: false }
        ];
        // for Daily Creative Sheet Main Columns First Show
        this.publisherCols = [
            // { field: "report_date", header: "Date" ,type:true},
            // { field: "report_day", header: "Day" ,type:true},
            // { field: "segment_name", header: "Segment Name" ,type:true},
            // { field: "offer_name", header: "Offer Name" ,type:true},
            // { field: "network_name", header: "Network Name" ,type:true},
            // { field: "creative_name", header: "Creative Name" ,type:true},
            // { field: "from_line", header: "From Line" ,type:true},
            // { field: "subject_line", header: "Subject Line" ,type:true},
            { field: "sent_count", header: "Sent", type: true },
            { field: "opens", header: "Opens", type: true },
            { field: "clicks", header: "Clicks", type: true },
            { field: "network_clicks", header: "N/W Click", type: true },
            { field: "unsub", header: "Unsub", type: true },
            { field: "conversion", header: "Conversions", type: true },
            { field: "revenue", header: "Revenue", type: true },
        ];
    }
}